
export const initialRouteData = [
    // {
    //     locationData: {
    //         il: "",
    //         ilce: "",
    //         lat: "",
    //         lng: "",
    //         location: "",
    //         bolge: "",
    //         ilId: "",
    //         ilceId: ""
    //     },
    //     adres: "",
    //     adresTarif: "",
    //     adresKaydedilsinMi: false,
    //     adresBaslik: "",
    //     date: "",
    //     dateEngec: "",
    //     saatBaslangic: "",
    //     saatBitis: "",
    //     saatAllTime: false,
    //     locationType: "yukleme",
        
    //     sevkBicimleri: {
    //         forklift: false,
    //         rampadan: false,
    //         vincle: false,
    //         elle: false,
    //         dokme: false,
    //         yandan: false,
    //         babalarCiksin: false,
    //     }
    // },
    // {
    //     locationData: {
    //         il: "",
    //         ilce: "",
    //         lat: "",
    //         lng: "",
    //         location: "",
    //         bolge: "",
    //         ilId: "",
    //         ilceId: ""
    //     },

    //     adres: "",
    //     adresTarif: "",
    //     adresKaydedilsinMi: false,
    //     adresBaslik: "",
    //     date: "",
    //     dateEngec: "",
    //     saatBaslangic: "",
    //     saatBitis: "",
    //     saatAllTime: false,
    //     locationType: "bosaltma",

    //     sevkBicimleri: {
    //         forklift: false,
    //         rampadan: false,
    //         vincle: false,
    //         elle: false,
    //         dokme: false,
    //         yandan: false,
    //         babalarCiksin: false,
    //     }
    // }

    //! güncel hali
    {
        locationData: {
            il: "",
            ilce: "",
            lat: "",
            lng: "",
            location: "",
            bolge: "",
            ilId: "",
            ilceId: ""
        },
        adres: "",
        adresTarif: "",
        adresKaydedilsinMi: false,
        adresBaslik: "",
        date: "",
        dateEngec: "",
        saatBaslangic: "",
        saatBitis: "",
        saatAllTime: false,
        locationType: "yukleme",
        order: 1,
        sevkBicimleri:[
            {
                id: 1,
                name: "Forkliftle",
                status: false,
            },
            {
                id: 2,
                name: "Rampadan",
                status: false,
            },
            {
                id: 3,
                name: "Vinçle",
                status: false,
            },
            {
                id: 4,
                name: "Elle",
                status: false,
            },
            {
                id: 5,
                name: "Dökme",
                status: false,
            },
            {
                id: 6,
                name: "Yandan",
                status: false,
            },
            {
                id: 7,
                name: "Babalar Çıksın",
                status: false,
            }
        ]
    },
    {
        locationData: {
            il: "",
            ilce: "",
            lat: "",
            lng: "",
            location: "",
            bolge: "",
            ilId: "",
            ilceId: ""
        },

        adres: "",
        adresTarif: "",
        adresKaydedilsinMi: false,
        adresBaslik: "",
        date: "",
        dateEngec: "",
        saatBaslangic: "",
        saatBitis: "",
        saatAllTime: false,
        locationType: "bosaltma",
        order: 2,
        sevkBicimleri:[
            {
                id: 1,
                name: "Forkliftle",
                status: false,
            },
            {
                id: 2,
                name: "Rampadan",
                status: false,
            },
            {
                id: 3,
                name: "Vinçle",
                status: false,
            },
            {
                id: 4,
                name: "Elle",
                status: false,
            },
            {
                id: 5,
                name: "Dökme",
                status: false,
            },
            {
                id: 6,
                name: "Yandan",
                status: false,
            },
            {
                id: 7,
                name: "Babalar Çıksın",
                status: false,
            }
        ]
    }
] 

export const initialPaketlemeData = [
    {
        activePaketlemeTypeId: 1,
        paketlemeType: "Palet",
        ustUsteYuklenmesin: false,
        ustUsteMiktar: 0,
        list:[
                {
                    en: 120,
                    boy: 80,
                    yukseklik: "",
                    agirlik:"",
                    sayisi:""
                }
            ]
    }
]

export const initialPaymentData = {
    hedefNakliyefiyat: "",
    fiyatlandirmaType: {
        value: 0,
        text: "TL"
    },
    fiyatYayinlansin: true,
    odemeSekli: {
        value: "",
        text: ""
    },
    odemeSekliDigerAciklama: "",
    yakitOrani: "",
    komisyonDurumu: {
        value: "",
        text: ""
    },
    komisyonMiktari: ""
}

export const initialYukData = {
    //! options
    yuklemeTuru: {
        value: "",
        text:""
    },

    //! text
    yukTuru: "",

    //! bool
    yukADR: false,
    yukAdrDescription: "",

    agirlikBirim: {
        value: "",
        text: ""
    },
    toplamAgirlik: "",
    toplamHacim: "",
    yukDesc: "",
    yukunDegeri: ""
}

export const initialAracData = {
    aracSayisi: 1,
    aracTypeName: "",
    aracTypeId: "",
    kasaTypeName: "",
    kasaTypeId: "",
    kasaTypeOptions: [], 
    zeminType: "",
    digerOzellikler: ""
}


const differenceFinder = (item) => {
    if(JSON.stringify({initialRouteData, initialPaketlemeData, initialPaymentData, initialYukData, initialAracData}) === JSON.stringify(item) && item.routeDistanceData === null){
        return false
    }
    return true
}

export default differenceFinder